import React from 'react'
 
export default function Page () {
    return (
        <div style={{ padding: 10 }}>
            {''}
        </div>
    )
}
